'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour les autorisations d'exploitation
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.autorisations-exploitation', {
        url: '/autorisations-exploitation',
        templateUrl: 'app/autorisations-exploitation/autorisations-exploitation.html',
        controller: 'AutorisationsExploitationController'
      })
      .state('main.autorisations-exploitation-details', {
        url: '/autorisations-exploitation/:id',
        templateUrl: 'app/autorisations-exploitation/autorisations-exploitation-details.html',
        controller: 'AutorisationsExploitationDetailsController'
      });
  }]);
